import { Phone } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, SectionHeading, GoldButton } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, PHONE, PHONE_LINK } from "@/data/site";

const FAQ = () => (
  <div data-testid="faq-page">
    <PageHero
      testId="faq-hero"
      kicker="Frequently Asked Questions"
      titleLines={["Answers, before", "you even ask."]}
      description="The questions drivers ask us most after an accident — answered plainly. For anything else, we're one call away."
    />

    <section className="mx-auto max-w-4xl px-6 py-28 md:px-10 md:py-36" data-testid="faq-list">
      <Reveal>
        <Accordion type="single" collapsible className="w-full border-t border-white/10" data-testid="faq-accordion">
          {FAQS.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="gap-6 py-8 text-left hover:no-underline"
              >
                <span className="flex items-baseline gap-6">
                  <span className="font-mono text-xs text-gold/70">0{i + 1}</span>
                  <span className="font-serif text-xl text-white transition-colors duration-300 hover:text-gold md:text-2xl">
                    {faq.question}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-8 pl-0 md:pl-14">
                <p className="max-w-2xl text-base leading-relaxed text-zinc-400">{faq.answer}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>

    <section className="bg-carbon py-24 md:py-32" data-testid="faq-cta">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-6 md:flex-row md:items-center md:px-10">
        <SectionHeading
          kicker="Still Unsure?"
          title="Speak to a specialist now."
        />
        <Reveal delay={0.15}>
          <GoldButton href={PHONE_LINK} testId="faq-call-button">
            <Phone className="h-4 w-4" strokeWidth={2} /> Call {PHONE}
          </GoldButton>
        </Reveal>
      </div>
    </section>
  </div>
);

export default FAQ;
